async function $1f24fd4cabc90194$var$fetchCitations() {
    const citations = [];
    try {
        const response = await fetch(`/api/citations/cites?openAlexKey=${openAlexKey}`);
        if (!response.ok) throw new Error(`Failed to fetch ${openAlexKey}`);
        const data = await response.json();
        for (const item of data)citations.push($1f24fd4cabc90194$var$formatDisplay(item));
    } catch (error) {
        console.error("Error fetching citations:", error);
        citations.push("Citations not available");
    }
    return citations;
}
function $1f24fd4cabc90194$var$formatDisplay(data) {
    const authors = $1f24fd4cabc90194$var$formatAuthors(data.authorships);
    const year = data.publication_year || "n.d.";
    const title = data.title || "[No title]";
    const journal = data.primary_location?.source?.display_name || "n.p.";
    const ordering = `<span class="m-r-20" title="${i18n_citationCount}">&uarr;${data.cited_by_count}</span>`;
    const url = data.primary_location?.landing_page_url || null;
    const target = url ? `<a class="title is-size-6" href="${url}" target="_blank">${title}</a>` : `<p class="title is-size-6">${title}</p>`;
    return `<div class="year">${year}</div><p class="authors">${ordering}${authors}</p>${target}<p class="journal">${journal}</p>`;
}
function $1f24fd4cabc90194$var$formatAuthors(authorships) {
    const authors = authorships.map((a)=>a.author.display_name);
    if (authors.length <= 20) return authors.join(", ").replace(/, ([^,]*)$/, " & $1");
    else {
        const first19 = authors.slice(0, 19).join(", ");
        const last = authors[authors.length - 1];
        return `${first19}, ... & ${last}`;
    }
}
async function $1f24fd4cabc90194$var$fetchReferences(openAlexItems) {
    const references = [];
    for (const itemUrl of openAlexItems){
        const id = itemUrl.split("/").pop();
        const url = `/api/citations/references?openAlexKey=${id}`; // No select
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Failed to fetch ${url}`);
            const data = await response.json();
            references.push(data);
        } catch (error) {
            console.error("Error fetching reference:", error);
            references.push("References not available");
        }
    }
    // sort references
    references.sort((a, b)=>b.cited_by_count - a.cited_by_count);
    return references.map((reference)=>$1f24fd4cabc90194$var$formatDisplay(reference));
}
function $1f24fd4cabc90194$var$toggleLoadingMessage(loadingType) {
    const checking = document.getElementById(`${loadingType}-loading`);
    checking.classList.toggle("is-hidden");
}
async function $1f24fd4cabc90194$var$populateList(id, items) {
    const list = document.getElementById(id);
    if (!list) return;
    items.forEach((text)=>{
        const li = document.createElement("li");
        li.innerHTML = text;
        list.appendChild(li);
    });
}
document.addEventListener("DOMContentLoaded", async ()=>{
    const doi = document.getElementById("doi0")?.href;
    if (!doi) return;
    const apiUrl = "/api/citations?doi=" + doi;
    const response = await fetch(apiUrl);
    const openAlexItem = await response.json();
    openAlexKey = new URL(openAlexItem.id).pathname.slice(1);
    if (openAlexItem.cited_by_count > 0) {
        document.getElementById("citation-wrapper").classList.toggle("is-hidden");
        document.getElementById("cited_by_count").innerHTML = openAlexItem.cited_by_count;
        document.getElementById(`citation-description-${openAlexItem.cited_by_count === 1 ? "one" : "other"}`).classList.toggle("is-hidden");
        const citationsLoadButton = document.getElementById("citations-load-button");
        citationsLoadButton.addEventListener("click", async ()=>{
            $1f24fd4cabc90194$var$toggleLoadingMessage("citations");
            citationsLoadButton.remove();
            await $1f24fd4cabc90194$var$populateList("citations", await $1f24fd4cabc90194$var$fetchCitations());
            $1f24fd4cabc90194$var$toggleLoadingMessage("citations");
        });
    }
    if (openAlexItem.referenced_works_count > 0) {
        document.getElementById("references-wrapper").classList.toggle("is-hidden");
        document.getElementById("referenced_works_count").innerHTML = openAlexItem.referenced_works_count;
        document.getElementById(`references-description-${openAlexItem.referenced_works_count === 1 ? "one" : "other"}`).classList.toggle("is-hidden");
        const referencesLoadButton = document.getElementById("references-load-button");
        referencesLoadButton.addEventListener("click", async ()=>{
            $1f24fd4cabc90194$var$toggleLoadingMessage("references");
            referencesLoadButton.remove();
            await $1f24fd4cabc90194$var$populateList("references", await $1f24fd4cabc90194$var$fetchReferences(openAlexItem.referenced_works));
            $1f24fd4cabc90194$var$toggleLoadingMessage("references");
        });
    }
});


//# sourceMappingURL=citations.js.map
